var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"BrandSkusTable"},[_c('v-data-table',{staticClass:"BrandSkusTable_Table",attrs:{"headers":_vm.headers,"items":_vm.items,"items-per-page":50,"loading":_vm.loading,"dark":"","dense":"","disable-sort":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }